import React, { useEffect } from 'react';
import {
  useAnalyticsPost,
  NarvarEventTypes,
  NarvarEventComponents,
} from '../../../hooks/Analytics';
import { useTheme } from '../../../hooks/useTheme';
import { LayoutTree } from '../DynamicLayout';
import useOrderTracking from '../../../hooks/useOrderTracking';
import Details from './components/Details';

export interface DriverDetailsProps {
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
}

const DriverDetails = ({
  featureName,
  layout = LayoutTree.FeatureLayout.LANDSCAPE,
}: DriverDetailsProps) => {
  const { panelcontainerNoneNone: containerStyle } = useTheme();

  const { getCurrentShipment } = useOrderTracking();
  const currentShipment = getCurrentShipment();

  const logEvent = useAnalyticsPost();

  useEffect(() => {
    if (!currentShipment) return;

    logEvent({
      eventComponent: NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      eventFeature: NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      eventType: NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      pageComponent: NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
    });
  }, [featureName, logEvent, currentShipment]);

  if (!currentShipment) return null;

  const { status, statusCode, vehicle } = currentShipment ?? {};

  if (
    !vehicle ||
    typeof statusCode !== 'string' ||
    typeof status !== 'string'
  ) {
    return <></>;
  }

  return (
    <div style={containerStyle}>
      <Details
        featureName={featureName}
        status={status}
        layout={layout}
        statusCode={statusCode}
        {...vehicle}
      />
    </div>
  );
};

export default DriverDetails;
